import common from "../common.js";

export default {
  async loadUserMetrics(context, payload) {
    const days = payload?.days ?? 30;
    const responseJson = await common.getRequest(
      context,
      payload,
      `userMetric?days=${days}`
    );
    const responseData = [];

    for (const key in responseJson) {
      const userMetric = {
        userId: responseJson[key].userId,
        userName: responseJson[key].userName,
        lastLogin: responseJson[key].lastLogin,
        lastActivity: responseJson[key].lastActivity,
        days: responseJson[key].days,
        loginsInPeriod: responseJson[key].loginsInPeriod,
        avgApiCallsPerDay: responseJson[key].avgApiCallsPerDay,
        numberOfSessionsToday: responseJson[key].numberOfSessionsToday,
        lastSessionLengthSeconds: responseJson[key].lastSessionLengthSeconds,
        averageNumberOfSessionsPerDay:
          responseJson[key].averageNumberOfSessionsPerDay,
        sessionsInPeriod: responseJson[key].sessionsInPeriod,
        averageSessionLengthSeconds:
          responseJson[key].averageSessionLengthSeconds,
      };
      responseData.push(userMetric);
    }
    context.commit("setUserMetrics", responseData);
  },
};
